import { useQuery } from "react-query";
import type { LanguageCode } from "../../../utils/language";
import { getBlogList } from "../api/blogService";

export const useBlogList = (language: LanguageCode) => {
  return useQuery(["blogList", language], () => getBlogList(language), {
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
  });
};
